export const DEFAULT_TITLE = 'Create and adapt instructional materials';
export const DEFAULT_PLACEHOLDER = 'What do you need?';

// Subjects that, when taught exclusively, mean the teacher is not ELA-oriented
export const EXCLUSIVELY_NON_ELA = ['Science', 'Math', 'Social Studies'];

// Default open-ended question shown when no more follow-up questions are needed
export const OPEN_ENDED_FINAL_QUESTION = {
  id: 'open_ended_final',
  type: 'open_ended',
  question: 'Anything else?',
  placeholder:
    'Optional: Add details about your student needs and interests, paste in learning objectives or standards, focus on a certain topic, etc.',
};

// Maximum number of URLs allowed in a single request
export const MAX_URLS = 3;

// Loading phrases for animated text during generation
export const loadingPhrases = [
  'Planning the flow\u2026',
  'Building the structure\u2026',
  'Aligning to your goal\u2026',
  'Sequencing steps\u2026',
  'Clarifying directions\u2026',
  'Tightening for clarity\u2026',
  'Calibrating rigor\u2026',
  'Adjusting cognitive demand\u2026',
  'Adding supports\u2026',
  'Building in relevance\u2026',
  'Making it engaging\u2026',
  'Making connections\u2026',
  'Layering in scaffolds\u2026',
  'Differentiating supports\u2026',
  'Making it accessible\u2026',
  'Reviewing vocabulary\u2026',
  'Checking for misconceptions\u2026',
  'Validating alignment\u2026',
  'Reviewing for readability\u2026',
  'Getting it classroom-ready\u2026',
];

// Static pill suggestions shown to signed-out users -- avoids hitting the autocomplete API
// when there's no user context to personalize the results anyway.
export const STATIC_PILL_SUGGESTIONS = {
  scaffold: [
    { text: 'Graphic organizer for a persuasive essay on climate change', category: 'skill' },
    { text: 'Sentence starters for analyzing primary sources', category: 'skill' },
    { text: 'Leveled reading passage on the American Revolution', category: 'skill' },
    { text: 'Vocabulary preview activity for a photosynthesis unit', category: 'skill' },
  ],
  'test-prep': [
    { text: 'Practice test questions for 8th grade Earth Science', category: 'skill' },
    { text: 'SAT-style reading passage with multiple choice questions', category: 'skill' },
    { text: 'AP US History DBQ practice prompt with scoring guide', category: 'skill' },
    { text: 'State test math review for 6th grade', category: 'skill' },
  ],
  math: [
    { text: 'Graphing linear equations practice with answer key', category: 'skill' },
    { text: 'Word problems for fraction division, grades 4\u20135', category: 'skill' },
    { text: 'Geometry proof practice worksheet', category: 'skill' },
    { text: 'Algebra warm-up problems for 8th grade', category: 'skill' },
  ],
  stations: [
    { text: 'Station rotation on the water cycle for 5th grade', category: 'skill' },
    { text: 'Math centers for multiplication facts fluency', category: 'skill' },
    { text: 'Station activity comparing primary sources on the Civil War', category: 'skill' },
    { text: 'Reading stations for main idea and supporting details', category: 'skill' },
  ],
  'study-guide': [
    { text: 'Study guide for the American Revolution unit', category: 'skill' },
    { text: 'Vocabulary study guide for Romeo and Juliet', category: 'skill' },
    { text: 'Biology cell functions review guide', category: 'skill' },
    { text: 'Ancient Rome unit study guide with key terms', category: 'skill' },
  ],
  quiz: [
    { text: '10-question quiz on the causes of World War I', category: 'skill' },
    { text: "Reading comprehension quiz for Charlotte's Web chapters 1\u20133", category: 'skill' },
    { text: 'Chemistry elements and periodic table quiz', category: 'skill' },
    { text: 'Exit ticket on adding and subtracting fractions', category: 'skill' },
  ],
  slides: [
    { text: 'Slide deck introducing the water cycle', category: 'skill' },
    { text: 'Mini lesson slides on solving two-step equations', category: 'skill' },
    { text: 'Slides walking through the causes of the Civil War', category: 'skill' },
    { text: 'Vocabulary preview slides for a unit on ecosystems', category: 'skill' },
  ],
};
